import React from 'react';

import type { TRefObject } from '~/src/features/center/InfoBlocks';
import type { IData } from '~/src/features/center/PanelTab';
import { useScroll } from '~/src/helpers/hooks/useScroll';

import * as ST from './styled';

interface IDataMod extends Omit<IData, 'id'> {
    id?: string,
    index: number,
    slotRefs: TRefObject,
}

export const Tab: React.FC<IDataMod> = ({ d, title, slotRefs, index }) => {
    const scrollToRef = useScroll();

    return (
        <ST.IconBlock
            onClick={() => scrollToRef(slotRefs.current[index])}
        >
            <ST.Icon viewBox='0 0 40 25' >
                <path d={d} />
            </ST.Icon>
            <ST.Title>{title}</ST.Title>
        </ST.IconBlock>
    );
};

export default Tab;


